import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Building2, ArrowRight } from "lucide-react";

interface BusinessAccessCTAProps {
  className?: string;
}

export function BusinessAccessCTA({ className = "" }: BusinessAccessCTAProps) {
  return (
    <div className={`mt-8 flex justify-center ${className}`}>
      <div className="bg-background border border-border rounded-xl p-5 flex flex-col sm:flex-row items-center justify-between gap-4 max-w-2xl w-full">
        <div className="flex items-start gap-3">
          <div className="p-2 rounded-lg bg-primary/10 border border-primary/20 shrink-0">
            <Building2 className="h-4 w-4 text-primary" />
          </div>
          <div className="space-y-0.5">
            <div className="flex items-center gap-2 flex-wrap">
              <h3 className="font-semibold text-sm text-foreground">
                XL – Komplett Sorglos
              </h3>
              <span className="text-[10px] font-medium bg-muted text-muted-foreground px-1.5 py-0.5 rounded">Individuelles Angebot</span>
            </div>
            <p className="text-xs text-muted-foreground">
              Sie sind eine Druckerei oder eine Behörde? Benötigen Sie individuelle Lösungen oder größere Volumen? Wir erstellen ein maßgeschneidertes Angebot.
            
            </p>
          </div>
        </div>
        <Button variant="outline" size="sm" asChild className="shrink-0">
          <Link to="/kontakt">
            Kontakt
            <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
          </Link>
        </Button>
      </div>
    </div>);

}